class requestDeposit  {
    constructor() {
        if(document.querySelector("[data-deposit-btn]") != null){
            document.querySelector("[data-deposit-btn]").addEventListener("click" , (event)=>{
               
                let is_swing_exist = false;
               if (window.globalVariables.cart.items.length > 0) {
                    window.globalVariables.cart.items.forEach(item=>{
                        if (item.id == 48121296552229 && item.properties['_main_product_handle'] == window.globalVariables.main_product_handle) {
                            is_swing_exist = true;
                        }
                    });
                    if (is_swing_exist == true) {
                      
                        notificationEle.updateNotification('Error', 'You already have this product in the cart.', {
                            type: 'error',
                            timeout: 5000
                        });
                        document.querySelector("#ModalClose-request-quote").click();
                        siteOverlay.prototype.hideOverlay();
                    }else{
                        this._collectDeposit(event);
                    }
               }else{
                this._collectDeposit(event);
               }
            });
        }
       
    }
    _collectDeposit(event){
      
        gtag("event", "add_to_cart", {
            currency: "USD",
            value: 500,
            items : [
              {
                item_id: `"48121296552229"`,
                item_name: `"${window.globalVariables.main_product_title}"`
              }
            ]
          });
     
        const submitButton = event.currentTarget;
        const body= JSON.stringify({
            'id': 48121296552229,
            'quantity': 1,
            'properties': { '_main_product_handle': window.globalVariables.main_product_handle , 'main_product_title': window.globalVariables.main_product_title   }
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body: body }})
          .then((response) => { return response.json(); })
          .then((data) => {
            
            // this._updateMinicart();
            if (window.globalVariables.template == 'cart') {
                window.location.reload();
            }else{
            ProductForm.prototype._updateMinicart();
            }
          }).catch((error) => { console.log(error); })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            document.querySelector("#ModalClose-request-quote").click();
            siteOverlay.prototype.hideOverlay();
          });;
    }
}

new requestDeposit()